var _path, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceIntroTapTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 15.6689C7 12.7505 13.5 18.7882 1.00184 16.351C1.00184 10.7719 0.998967 9.83879 1.0004 4.26103C13.5 6.71275 6.5 1.13928 19 3.57757V15.6689Z",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.832 7C17.1752 7 15.832 5.72081 15.832 4.14286C15.832 3.73651 15.9211 3.34998 16.0817 3",
    stroke: "#20242E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9832 5.002C5.14005 6.65142 3.99375 8.10962 2.42288 8.259C2.01836 8.29747 1.62513 8.24539 1.26153 8.11868",
    stroke: "#20242E",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9128 15.4331C15.4839 13.8327 16.3719 12.2042 17.8961 11.7958C18.2886 11.6906 18.685 11.6766 19.0646 11.7411",
    stroke: "#20242E",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13C2.65685 13 4 14.2792 4 15.8571C4 16.2635 3.91093 16.65 3.75037 17",
    stroke: "#20242E",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 2.5,
    fill: "#20242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIntroTapTop);
export default __webpack_public_path__ + "static/media/invoice-intro-tap-top.d72590c5805363f7329d2c62e26553dc.svg";
export { ForwardRef as ReactComponent };